import { createContext } from 'react';

import type { HeadElement } from '@xing-com/crate-xinglet/internal';

export type HelmetContextType = {
  addElements?: (element: HeadElement[]) => void;
  removeElements?: (element: HeadElement[]) => void;
};

export const HelmetContext = createContext<HelmetContextType>({});
